module.exports = __webpack_public_path__ + "img/firetalks.03b48dde.svg";